import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { Trophy, Medal, Users, Award, Gamepad2 } from 'lucide-react';
import { useFriendRequests } from '@/features/friends/api';
import { useAuth } from '@/providers/AuthProvider';
import { cn } from '@/lib/utils';
const ITEMS = [
    { to: '/games', label: 'Jeux', icon: Gamepad2 },
    { to: '/leaderboard', label: 'Classements', icon: Medal },
    { to: '/achievements', label: 'Trophées', icon: Award },
    { to: '/battle-pass', label: 'BP', icon: Trophy },
    { to: '/friends', label: 'Amis', icon: Users },
];
/**
 * Bottom nav fixée en bas pour les mobiles (md:hidden). Reproduit la nav
 * principale du header (cachée en mobile) avec un format pouce-friendly.
 */
export function MobileNav() {
    const { user } = useAuth();
    const { data: requests } = useFriendRequests();
    const incomingCount = (requests ?? []).filter((r) => r.direction === 'incoming').length;
    if (!user)
        return null;
    return (_jsx("nav", { "aria-label": "Navigation principale", className: "fixed inset-x-0 bottom-0 z-30 border-t border-ink-800/80 bg-ink-950/90 backdrop-blur-md md:hidden", style: { paddingBottom: 'env(safe-area-inset-bottom)' }, children: _jsx("ul", { className: "grid grid-cols-5", children: ITEMS.map(({ to, label, icon: Icon }) => (_jsx("li", { children: _jsxs(NavLink, { to: to, className: ({ isActive }) => cn('relative flex flex-col items-center gap-0.5 py-2 transition-colors', isActive ? 'text-electric-300' : 'text-ink-400 hover:text-ink-100'), children: [_jsx(Icon, { className: "h-5 w-5" }), _jsx("span", { className: "text-2xs uppercase tracking-wider", children: label }), to === '/friends' && incomingCount > 0 && (_jsx("span", { "aria-label": `${incomingCount} demande(s)`, className: "absolute right-3 top-1 grid h-4 w-4 place-items-center rounded-full bg-flame-500 text-[9px] font-bold text-white shadow-glow-flame", children: incomingCount }))] }) }, to))) }) }));
}
